export default "<h3>August 21, 2020</h3>\r\n<p>Version 2.01 fixes a few bugs with online multiplayer.</p>";